<template>
  <div class="container-fluid h-100">
    <nav class="navbar navbar-dark fixed-top bg-dark flex-nowrap p-0 shadow">
      <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="#">DulyNoted</a>
      <b-nav-item class='d-none d-md-block' disabled> {{ userName }}</b-nav-item>
      <b-nav-item-dropdown class='m-2 d-block d-md-none bg-dark' :text='currentRouteName' v-if='isLoggedIn' variant="primary" right>
        <b-dropdown-item v-if='currentRouteName != "OpenLists"'><router-link class="dropdown-item" to="/">Open Lists</router-link></b-dropdown-item>
        <b-dropdown-item v-if='currentRouteName != "ClosedLists"'><router-link class="dropdown-item" to="/closedlists">Closed Lists</router-link></b-dropdown-item>
        <b-dropdown-item @click='logout'><span class="dropdown-item">Sign out</span></b-dropdown-item>
      </b-nav-item-dropdown>
    </nav>
    <div v-if='isLoggedIn'>
      <div class="row" style='padding-top:2%'>
        <nav class="col-md-2 d-none d-md-block bg-light sidebar">
          <div class="sidebar-sticky" id="navbarSupportedContent">
            <ul class="nav flex-column navbar-nav px-3">
              <li class="nav-item">
                <router-link class="nav-link" to="/">
                  <p :class='currentRouteName === "OpenLists" ? "text-primary mb-0 font-weight-bold" : "mb-0"'>Open Lists</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/closedlists">
                  <p :class='currentRouteName === "ClosedLists" ? "text-primary mb-0 font-weight-bold" : "mb-0"'>Closed Lists</p>
                </router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click='logout' href="#" v-if='isLoggedIn'>Sign out</a>
              </li>
            </ul>
          </div>
        </nav>
        <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4">
          <div class="row d-block d-md-none" style='padding-top:5%'></div>
          <router-view/>
        </main>
      </div>
    </div>
    <div id='login' v-if='!isLoggedIn' class='row justify-content-center h-100 d-inline-bldock' style='padding-top:20%'>
      <router-view/>
    </div>
  </div>
</template>

<script>

import { AUTH_LOGOUT } from '@/store/actions/auth'

export default {
  name: 'App',
  data () {
    return {
      userName: this.$store.getters.userName
    }
  },
  methods: {
    logout () {
      this.$store.dispatch(AUTH_LOGOUT)
      this.userName = null
      this.$router.push('/login')
      window.location.reload()
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isAuthenticated
    },
    currentRouteName () {
      return this.$route.name
    }
  },
  created () {
    // let featherScript = document.createElement('script')
    // featherScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.1/Chart.min.js')
    // document.head.appendChild(featherScript)
  }
}

</script>

<style>
body {
  font-size: .875rem;
}

.feather {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}

/*
 * Sidebar
 */

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100; /* Behind the navbar */
  padding: 48px 0 0; /* Height of navbar */
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}

/*
 * Content
 */

[role="main"] {
  padding-top: 48px; /* Space for fixed navbar */
}

/*
 * Navbar
 */

.navbar-brand {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: 1rem;
  background-color: rgba(0, 0, 0, .25);
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
}

.navbar .form-control {
  padding: .75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, .1);
  border-color: rgba(255, 255, 255, .1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
}

.btn-primary {
  background-color: #5f7b98;
}
@media screen and (max-width: 767px) {
    #login {
      background-image: url('/static/img/mobileHero2-1024x571.png');
      background-repeat: no-repeat, repeat;
      background-position: center;
      background-size: cover;
    }
}
@media screen and (min-width: 768px) {
    #login {
      background-image: url('/static/img/Artboard-3-1024x569.png');
      background-repeat: no-repeat, repeat;
      background-position: center;
      background-size: cover;
      height: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue